import { useTranslate } from "react-admin";
import { Button } from "@mui/material";
import { Toolbar } from "react-admin";
export const SimpleToolbar = ({ onClose }) => {
    const translate = useTranslate();
    return (
        <Toolbar sx={{ justifyContent: "space-between" }}>
            <Button variant="contained" type="submit">
                {translate("equip.save")}
            </Button>
            <Button variant="outlined" color="primary" onClick={onClose}>
                {translate("ra.action.cancel")}
            </Button>
        </Toolbar>
    );
};
